import dynamic from 'next/dynamic'
import { memo } from 'react'
import { useHealthAppStateSelector } from '../../Hooks/useHealthAppState'
import { useLayoutSelector } from '../../Hooks/useLayout'
import {
    useConfirmationSelector,
    useDialogSelector,
    useDrawerSelector,
} from '../../Hooks/useModal'
import { useScreenStateSelector } from '../../Hooks/useScreenState'

const dialogPromise = import('../Modals/Dialog')
const AppDialog = dynamic(() => dialogPromise)
const AppConfirmation = dynamic(() => import('../Modals/Confirmation'))
const AppDrawer = dynamic(() => import('../Modals/Drawer'))
const DisconnectWarningSnackbar = dynamic(
    () => import('../Modals/DisconnectWarningSnackbar'),
)
interface ModalLayoutProps {
    showConnectingScreen: boolean
    delayReconnectionScreen: boolean
}

const Modals = (props: ModalLayoutProps) => {
    const { showConnectingScreen, delayReconnectionScreen } = props
    const showConfirmation = useConfirmationSelector('show')
    const showDialog = useDialogSelector('show')
    const showDrawer = useDrawerSelector('show')
    const portrait = useScreenStateSelector('portrait')
    const fullWindow = useLayoutSelector('fullWindow')
    const socketPaused = useHealthAppStateSelector('paused')
    return (
        <>
            {showConnectingScreen && !delayReconnectionScreen && (
                <DisconnectWarningSnackbar paused={socketPaused} />
            )}
            {showDialog && <AppDialog />}
            {showDrawer && (
                <AppDrawer fullWindow={fullWindow} portrait={portrait} />
            )}
            {showConfirmation && <AppConfirmation />}
        </>
    )
}

export default memo(Modals)
